import { useDispatch, useSelector } from "react-redux"
import { useState } from "react"
import { dismissSystemAlert } from "../../lib/fetchApi"
import { notificationActions } from "../../store/notifications"
import { systemActions } from "../../store/system"
import Button from "../common/Button"

import classes from './SystemAlerts.module.css'
import { getItemFromStorageSimple, setStorageItem } from "../../lib/script"

export default function SystemAlertsItemV2({itemData, rebuild}) {

    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const userToken = useSelector(state => state.user.token)
    const persistentSystemAlerts = getItemFromStorageSimple('persistentSystemAlerts')
    const alerts = useSelector(state => state.system.systemAlerts)

    async function removeAlertHandler() {
        setLoading(true)
        try {
            let dismiss = await dismissSystemAlert(userToken, itemData?.id)

            if (dismiss && dismiss.errorMessage) {
                dispatch(notificationActions.setError(dismiss))     
            } else {            
                dispatch(notificationActions.setError({errorMessage: dismiss?.message, type: 'success'}))          
                if (alerts) {
                    dispatch(systemActions.removeAlert(itemData?.id))
                }

                const index = persistentSystemAlerts?.findIndex(object => {
                    return object.id == itemData?.id
                })          


                if (index != null && index != -1) {
                    persistentSystemAlerts.splice(index, 1)  

                    if (persistentSystemAlerts.length) {
                        setStorageItem('persistentSystemAlerts', persistentSystemAlerts)
                    } else {
                        localStorage.removeItem('persistentSystemAlerts')
                    }

                    if(rebuild) {
                        rebuild()
                    }
                }
                
                
            }
        } finally {
            setLoading(false)
        }
    }

    return <div className={classes.item_container_v2}>
        <div>
            {itemData && itemData.subject && <h3>{itemData.subject}</h3>}
            <div dangerouslySetInnerHTML={{__html: itemData.description}}/>
        </div>
        <Button click={removeAlertHandler} isLoading={loading} btnStyle={'btn_small'}>Dismiss</Button>
    </div>
}